import { Button, Typography } from '@breetometer/components';
import { FirstBeneficiaryIcon, PlusIcon } from 'BreetAssets';

import type { INoBeneficiary } from '../AddBeneficiary.helpers';

const NoBeneficiary = ({ intent, addAccount }: INoBeneficiary) => (
	<div
		className='payment-request-form_nobeneficiary'
		data-testid='no-beneficiary'
	>
		<FirstBeneficiaryIcon />
		<Typography className='color-primary-50'>You need to have a saved beneficiary to {intent}.</Typography>
		<Button
			label='Add Account'
			variant='tertiary'
			leadingIcon={<PlusIcon className='plusicon' />}
			onClick={addAccount}
		/>
	</div>
);

export default NoBeneficiary;
